<template>
  <div class="page-header">
    <div class="page-header__navigation-left">
      <n-link class="u-reset page-header__back-link" :to="backLocation">
        <responsive-img class="page-header__img" v-bind="arrowImg" alt="" />
      </n-link>
    </div>
    <div class="page-header__title">
      <h1>
        <template v-if="$scopedSlots.title">
          <slot name="title" />
        </template>
        <template v-else>
          {{ $t(title) }}
        </template>
      </h1>
    </div>
  </div>
</template>

<script>
  import { getArrow } from '@/assets/js/util/misc/image'
  import { pageThemeIds, pageThemes } from '@/assets/js/model/page-theme'
  import ResponsiveImg from '~/components/responsive-img/responsive-img'

  const defaultPageTheme = pageThemes.find(({ id }) => id === pageThemeIds.CUSTOM)

  export default {
    components: { ResponsiveImg },
    props: {
      backLocation: {
        type: [String, Object],
        required: true,
      },
      pageTheme: {
        type: Object,
        default() {
          return defaultPageTheme
        },
      },
      title: {
        type: String,
        default: null,
      },
    },
    computed: {
      arrowImg() {
        return getArrow(this.pageTheme, 'left', 'page_header')
      },
    },
  }
</script>

<style lang="scss" src="./_page-header.scss" />
